var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_169398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6074 4.50802L15.4692 4.23163H15.1602H4.03652C2.64461 4.23163 1.51074 5.35236 1.51074 6.74567V24.9705C1.51074 26.3606 2.64635 27.4845 4.02694 27.4845H29.3279C30.7179 27.4845 31.8441 26.3574 31.8441 24.9665V10.7956C31.8441 9.40259 30.7105 8.27761 29.3152 8.27761H17.4922L15.6074 4.50802Z",
    fill: "#3990E4",
    stroke: "#414955"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.627 11.7555L13.8115 8.33669H3.82875C2.82469 8.33669 2.01074 9.09709 2.01074 10.0385V25.4383C2.01074 26.3782 2.82746 27.1401 3.82015 27.1401H29.5347C30.534 27.1401 31.3441 26.3772 31.3441 25.4349V13.4607C31.3441 12.5189 30.5298 11.7555 29.5233 11.7555H15.627Z",
    fill: "#5AA5ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_169398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.677429 0.731628)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectory);
export default __webpack_public_path__ + "static/media/directory.c3e0467403ed581cbcc067f144808f69.svg";
export { ForwardRef as ReactComponent };